import { styled, CardMedia } from '@mui/material';
import { theme } from 'assets/themes/zizzi';

export const Media = styled(CardMedia)`
  height: 180px;
  position: relative;

  ${theme.breakpoints.up('sm')} {
    height: 260px;
  }

  &:after {
    background: linear-gradient(150deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 60%);
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;
